import dynamic from 'next/dynamic';

const MyIssuesListContent = dynamic(() =>
  import('./MyIssuesListContent/MyIssuesListContent')
);
const MyIssuesMailBoxContent = dynamic(() =>
  import('./MyIssuesMailBoxContent/MyIssuesMailBoxContent')
);

export { MyIssuesListContent, MyIssuesMailBoxContent };
